export const isValidFirstName = (firstName: string): boolean =>
  /^[a-zA-Z' ]+$/.test(firstName) && firstName.trim() !== '';

export const isValidLastName = (lastName: string): boolean =>
  /^[a-zA-Z'-]+$/.test(lastName) && lastName.trim() !== '';

export const isValidEmail = (email: string): boolean =>
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
    email,
  ) && !/([À-ž]|[^\x00-\x7F]+)/.test(email);

export function isInputTruthy<T extends Object>(
  input: T | false | undefined | null | '' | 0,
): input is T {
  return !!input;
}
